import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.405.5c.053.004.066.003.119.012a.9.9 0 0 1 .47.239l5.25 5.143c.037.038.047.046.079.088a.847.847 0 0 1 0 1.036c-.032.041-.042.05-.079.088l-5.25 5.143c-.039.035-.048.045-.09.077a.89.89 0 0 1-.905.09.87.87 0 0 1-.494-.686.84.84 0 0 1 .173-.605c.032-.042.042-.05.078-.088L5.388 6.5.756 1.963l-.04-.043c-.034-.04-.044-.05-.073-.093a.85.85 0 0 1-.143-.5.86.86 0 0 1 .726-.815c.053-.009.066-.008.12-.012z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }